import { IsBoolean, IsDefined, IsObject, IsOptional, IsString, ValidateIf, isDefined, IsNotEmpty } from 'class-validator';

import { FieldLimiters } from '../field-limiters/field-limiters';
import { ReferenceField } from '../reference-field';

export class TaxonomyReferenceFieldUpdateRequest implements Partial<Omit<ReferenceField, 'isSystem' | 'fieldTitle' | 'fieldType'>> {
    @ValidateIf((o: TaxonomyReferenceFieldUpdateRequest) => isDefined(o.uuid) || !isDefined(o.referenceUuid) || !isDefined(o.fieldName))
    @IsDefined({ message: '"uuid" is required when "referenceUuid" or "fieldName" is not set' })
    @IsString()
    @IsNotEmpty()
    public uuid?: string;

    @ValidateIf((o: TaxonomyReferenceFieldUpdateRequest) => isDefined(o.referenceUuid) || !isDefined(o.uuid))
    @IsDefined({ message: '"referenceUuid" is required when "uuid" is not set' })
    @IsString()
    @IsNotEmpty()
    public referenceUuid?: string;

    @ValidateIf((o: TaxonomyReferenceFieldUpdateRequest) => isDefined(o.fieldName) || !isDefined(o.uuid))
    @IsDefined({ message: '"fieldName" is required when "uuid" is not set' })
    @IsString()
    @IsNotEmpty()
    public fieldName?: string;

    @IsOptional()
    @IsBoolean()
    public required?: boolean;

    @IsOptional()
    @IsBoolean()
    public display?: boolean;

    @IsOptional()
    @IsObject()
    public limiters?: Partial<FieldLimiters>;

    constructor(data?: Partial<TaxonomyReferenceFieldUpdateRequest>) {
        this.uuid = data?.uuid;
        this.referenceUuid = data?.referenceUuid;
        this.required = data?.required;
        this.display = data?.display;
        this.limiters = data?.limiters;
        this.fieldName = data?.fieldName;
    }
}
